import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';
import { ProgramIncrementField } from './ProgramIncrementField';

export class ProgramIncrementName extends ProgramIncrementField {
  get title() {
    return `${terminology('Program increment')} name`;
  }

  exampleContents(): FieldContentsData {
    return { text: `Example ${terminology('program increment')}` };
  }

  contentsForRecord(record): FieldContentsData {
    let { programIncrement } = record;

    if (programIncrement) {
      return { text: programIncrement.name };
    }

    return {};
  }
}
